import React from "react";
import axios from "axios";
import constant from "../../constant";
import "./style.scss";

export default class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      discount_list: [],
      discount_data: [],
      is_check_discount: false,
      show_dis_add_row: false,
      sel_days: "",
      sel_price: "",
      currency_id: 1,
      currency_code: "EUR",
      errors: {}
    };
  }

  componentDidMount() {
    let spaceId = this.props.spaceId;
    let get_list = JSON.parse(localStorage.getItem(this.props.spaceId));

    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "get_discount_data",
          desk_id: spaceId,
          space_type: get_list["spacetypes"],
          listing: this.props.listing
        }
      })
      .then(res => {
        this.setState({
          discount_list: res.data.full_dis ? res.data.full_dis : [],
          discount_data: res.data.no_of ? res.data.no_of : [],
          is_check_discount: res.data.count_of_disc > 0 ? true : false,
          currency_code: get_list["currency_code"],
          currency_id: get_list["currencys"]
        });
      });
  }

  handleChange = (e, field) => {
    let fields = this.state;
    fields[field] = e.target.value;

    this.setState({ fields });
  };

  handleCheck = (e, field) => {
    let fields = this.state;
    fields[field] = e.target.checked;
    this.setState({ fields });
  };

  add_new_field() {
    console.log(this.state.discount_data.length);
    if (this.state.discount_data.length !== 0) {
      // alert(2);
      this.setState({
        show_dis_add_row: !this.state.show_dis_add_row
      });
    }
  }

  save_discount = () => {
    let get_list = JSON.parse(localStorage.getItem(this.props.spaceId));
    if (this.validation()) {
      axios
        .get(`${constant.phpHost}action/listing.php`, {
          params: {
            todo: "add_discount",
            desk_id: this.props.spaceId,
            space_type: get_list["spacetypes"],
            sel_days: this.state.sel_days,
            sel_price: this.state.sel_price,
            currency_id: this.state.currency_id,
            listing: this.props.listing
          }
        })
        .then(res => {
          this.setState({
            sel_days: "",
            sel_price: "",
            discount_list: res.data.full_dis ? res.data.full_dis : [],
            discount_data: res.data.no_of ? res.data.no_of : [],
            show_dis_add_row: false
          });
        });
    }
  };

  delete_discount = (id, e) => {
    let get_list = JSON.parse(localStorage.getItem(this.props.spaceId));
    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "delete_discount",
          desk_id: this.props.spaceId,
          space_type: get_list["spacetypes"],
          dis_id: id,
          listing: this.props.listing
        }
      })
      .then(res => {
        this.setState({
          discount_list: res.data.full_dis ? res.data.full_dis : [],
          discount_data: res.data.no_of ? res.data.no_of : [],
          show_dis_add_row: false
        });
      });
  };

  validation() {
    let fields = this.state;
    let get_list = JSON.parse(localStorage.getItem(this.props.spaceId));
    let errors = {};
    let formIsValid = true;
    var regularExpression = /^[0-9.,]+$/;

    if (!fields["sel_days"]) {
      formIsValid = false;
      errors["sel_days"] = "Enter day";
    }

    if (!regularExpression.test(fields["sel_price"])) {
      formIsValid = false;
      errors["sel_price"] = "Please enter valid price";
    } else {
      let orig_price = get_list["cost_v"];
      let sel_days = fields["sel_days"];
      let sel_price = fields["sel_price"];

      let arr = {
        "5 Days": 5,
        "2 Weeks": 14,
        "1 Month": 30,
        "3 Months": 90,
        "5 hours": 5,
        "10 hours": 10,
        "15 hours": 15,
        "20 hours": 20
      };

      let max_price = orig_price * arr[sel_days];

      console.log(max_price);

      if (!sel_price) {
        formIsValid = false;
        errors["sel_price"] = "Enter price";
      }

      if (
        parseFloat(max_price) <= parseFloat(sel_price) ||
        parseFloat(orig_price) >= parseFloat(sel_price)
      ) {
        formIsValid = false;
        errors["sel_price"] =
          "Discount amount from " + orig_price + " to " + max_price;
      }
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  // Bottom Button
  buttonStep = step => {
    if (step === "prev") {
      this.props.stepButton(3);
    } else {
      this.props.stepButton(5);
    }
  };

  render() {
    const { errors, discount_data, discount_list } = this.state;

    function error(name) {
      if (errors[name]) {
        return <span className="error">{errors[name]}</span>;
      }
    }

    return (
      <div>
        <h3 className="heading"> Price Discount</h3>
        <div className="price_discount">
          <div className="form-group check_discount">
            <label className="check_list">
              <input
                type="checkbox"
                checked={this.state.is_check_discount ? "checked" : ""}
                onChange={e => this.handleCheck(e, "is_check_discount")}
              />
              <span className="checkmark" />
              Do you want to add a price discount?
            </label>
          </div>

          {this.state.show_dis_add_row ? (
            <div className="add_price">
              <div className="inner">
                <div className="form-group">
                  <select onChange={e => this.handleChange(e, "sel_days")}>
                    <option value={0}>Select</option>
                    {discount_data.map((data, i) => {
                      return (
                        <option value={data} key={i}>
                          {data}
                        </option>
                      );
                    })}
                  </select>
                  {error("sel_days")}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Enter amount"
                    onChange={e => this.handleChange(e, "sel_price")}
                  />

                  {error("sel_price")}
                </div>

                <div className="form-group">{this.state.currency_code}</div>
                <div className="button">
                  <button onClick={() => this.save_discount()}>Save</button>
                  <button onClick={() => this.add_new_field()}>Close</button>
                </div>
              </div>
            </div>
          ) : null}

          {this.state.is_check_discount ? (
            discount_list.length > 0 ? (
              <div className="price_table">
                <div className="table_row head">
                  <label>
                    No.of
                    {this.state.spacetypes > 1 ? " hours" : " days"}
                  </label>
                  <label>Price</label>
                  <label>Currency</label>
                  <label>Action</label>
                </div>
                {discount_list.map((dl, i) => (
                  <div className="table_row" key={i}>
                    <span>{dl.days_dis}</span>
                    <span>{dl.price_dis}</span>
                    <span>{dl.cur_code}</span>
                    <span>
                      <i
                        className="fa fa-times"
                        aria-hidden="true"
                        onClick={this.delete_discount.bind(this, dl.id)}
                      />
                      {discount_data.length !== 0 ? (
                        <i
                          className="fa fa-plus"
                          onClick={() => this.add_new_field()}
                          aria-hidden="true"
                        />
                      ) : null}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="add_button_block">
                <span onClick={() => this.add_new_field()}>
                  Click here to add discount
                </span>
              </div>
            )
          ) : null}
        </div>

        <div className="button">
          <div className="prev_button">
            <button onClick={() => this.buttonStep("prev")}>
              <span>&#x276E;</span>
              {window.innerWidth < 767 ? "PREV" : "PREVIOUS STEP"}
            </button>
          </div>

          <div className="next_button">
            <button onClick={() => this.buttonStep("next")}>
              {window.innerWidth < 767 ? "NEXT" : "NEXT STEP"}
              <span>&#x276F;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
